export default __webpack_public_path__ + "static/media/icon-whatsapp-uae.acc29d8a.svg";